module.exports = __webpack_public_path__ + "media/img/pages/companies/be-07972a0e73f50b213d92f212daff84cf.jpg";